import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
  Input,
  Label,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@redbax/ui-kit';

const ecosystems = ['npm', 'PyPI', 'NuGet', 'Maven', 'Go', 'RubyGems', 'crates.io'] as const;

interface BlocklistEntryFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: {
    ecosystem: string;
    packageName: string;
    versionPattern?: string | null;
    reason?: string | null;
  }) => void;
  isSubmitting: boolean;
  fixedEcosystem?: string;
}

export function BlocklistEntryForm({ open, onOpenChange, onSubmit, isSubmitting, fixedEcosystem }: BlocklistEntryFormProps) {
  const [ecosystem, setEcosystem] = React.useState(fixedEcosystem ?? 'npm');
  const [packageName, setPackageName] = React.useState('');
  const [versionPattern, setVersionPattern] = React.useState('');
  const [reason, setReason] = React.useState('');

  const handleSubmit = () => {
    if (!packageName.trim()) return;
    onSubmit({
      ecosystem,
      packageName: packageName.trim(),
      versionPattern: versionPattern.trim() || null,
      reason: reason.trim() || null,
    });
    setPackageName('');
    setVersionPattern('');
    setReason('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add to Blocklist</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          {!fixedEcosystem && (
            <div>
              <Label htmlFor="bl-ecosystem">Ecosystem</Label>
              <Select value={ecosystem} onValueChange={setEcosystem}>
                <SelectTrigger className="mt-1">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {ecosystems.map((eco) => (
                    <SelectItem key={eco} value={eco}>
                      {eco}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          <div>
            <Label htmlFor="bl-package">Package Name</Label>
            <Input
              id="bl-package"
              value={packageName}
              onChange={(e) => setPackageName(e.target.value)}
              placeholder="e.g., lodash"
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="bl-version">Version Pattern (optional)</Label>
            <Input
              id="bl-version"
              value={versionPattern}
              onChange={(e) => setVersionPattern(e.target.value)}
              placeholder="e.g., <4.17.21"
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="bl-reason">Reason (optional)</Label>
            <Input
              id="bl-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="e.g., Known supply chain risk"
              className="mt-1"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!packageName.trim() || isSubmitting}>
            {isSubmitting ? 'Adding...' : 'Add'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
